module.exports = __webpack_public_path__ + "img/img5.195bff73.png";